import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

import UITableUtils from "../util/UITableUtils";
import CollapsibleNote from "../base/CollapsibleNote";
import DelNav from './DelNav';

import INotes from "./INotes";
import UIUtils from "../util/UIUtils";
import LogoUtils from "../util/LogoUtils";
import ApiUtils from '../util/ApiUtils';
import SPCalc from '../util/SPCalc';
import Utilities from "../util/Utilities";
import SPUtilities from "../util/SPUtilities";
import FavUtils from "../util/FavUtils";
import RespUtils from "../util/RespUtils";

import IUtils from "./IUtils";
import DelHeader from "./DelHeader";

class Votes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      votes: [],
      coinStat: {},
      delegate: {},
      notification: {},
      width: window.innerWidth,
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    var delegateId = IUtils.getDelegateId(this);
    const allData = await ApiUtils.get("listData?type=listVotes&delegateId=" + delegateId);
    // console.log(allData)
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let delegate = allData["delegate"];
    if (delegate) {
      let votes = allData["data"];
      let coinStat = allData["coinStat"];
      let newVotes = Utilities.addIndex(votes);
      this.setState({votes: votes, coinStat: coinStat,
        delegate: delegate, notification: allData["notification"]});
    }

    this.setState({isLoading: false});
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);
    if (loadMsg) return loadMsg;

    var columns;
    // {text: "Perf", dataField: "productivity", sort: true, formatter: IUtils.productivityFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    if (RespUtils.isMobileView()) {
      columns = [
        {text: "#", dataField: "index", sort: true, headerStyle: Utilities.width(3)},
        {text: "Address", dataField: "address", formatter: IUtils.addressFormatter, sort: true, headerStyle: Utilities.width(35)},
        {text: "Votes", dataField: "votes", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Votes", dataField: "weightedVotes", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
      ];
    } else {
      columns = [
        {text: "#", dataField: "index", sort: true, headerStyle: Utilities.width(3)},
        {text: "Address", dataField: "address", formatter: IUtils.addressFormatterLong, sort: true, headerStyle: Utilities.width(35)},
        {text: "Votes", dataField: "votes", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Weighted Votes", dataField: "weightedVotes", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
      ];
    }

    let options = UIUtils.getPageOptions(this, 50);
    return (
      <div>
        <DelHeader delegate={this.state.delegate} notification={this.state.notification} desktopView={true} title="Votes"/>
        <p/>
        <BootstrapTable keyField='index' data={ this.state.votes } filter={ filterFactory() }
          columns={ columns } hover striped options={options}
          expandableRow={ () => { return true; } } rowStyle={UITableUtils.getMainTableRowStyle}
          condensed noDataIndication="Table is Empty/Loading" pagination={paginationFactory(options)}/>
        <p/>
        <DelNav delegateId={this.state.delegate.delegateId}/>
      </div>
    );
  }

}

export default Votes;



// WEBPACK FOOTER //
// ./src/iotex/Votes.js